/* WWP product page bottom: Frequently Bought Together + What Pet Parents Also Wuv */
(function () {
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m || window.wwpPdp) return; window.wwpPdp = true;
  var handle = decodeURIComponent(m[1]);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var esc = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
  var gbp = function (p) { return '\u00a3' + (p / 100).toFixed(2); };
  var getJSON = function (u) { return fetch(u).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }); };
  var pence = function (v) { if (typeof v === 'number') return v; var s = String(v || 0); return s.indexOf('.') > -1 ? Math.round(parseFloat(s) * 100) : parseInt(s, 10); };
  var FBT_DISCOUNT = 0.05; // 5% off when all 3 items selected
  function norm(p) {
    var fi = p.featured_image, f0 = p.images && p.images[0];
    var im = (typeof fi === 'string' ? fi : fi && (fi.src || fi.url)) || (typeof f0 === 'string' ? f0 : f0 && f0.src) || '';
    if (im.indexOf('//') === 0) im = 'https:' + im;
    return { id: p.id, title: p.title, img: im ? im + (im.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '',
      variants: (p.variants || []).map(function (v) { return { id: v.id, title: v.title, price: pence(v.price), a: !!v.available }; }) };
  }
  function liveId() {
    var el = document.querySelector('product-info form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] [name="id"]');
    return (el ? parseInt(el.value, 10) : parseInt(new URLSearchParams(location.search).get('variant'), 10)) || 0;
  }
  function companions(prod) {
    var q = root + 'recommendations/products.json?limit=8&product_id=' + prod.id + '&intent=';
    return Promise.all([getJSON(q + 'complementary'), getJSON(q + 'related'), getJSON(root + 'collections/popular-products/products.json?limit=12')]).then(function (r) {
      var out = [], seen = {}; seen[prod.id] = 1;
      [].concat(r[0].products || [], r[1].products || [], r[2].products || []).forEach(function (p) {
        var n = norm(p);
        if (seen[n.id] || !n.variants.some(function (v) { return v.a; })) return;
        seen[n.id] = 1; out.push(n);
      });
      return out.slice(0, 2);
    });
  }
  var BAG = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>';
  function buildFbt(box, items) {
    var rows, thumbs, btn, label, totalEl, discountEl;
    var avail = function (it) { return it.variants.filter(function (v) { return v.a; }); };
    box.innerHTML = '<h2 class="wwp-fbt__title">Frequently Bought Together</h2><p class="wwp-fbt__sub">Handy extras that go well with this product. <strong class="wwp-fbt__deal">Select all 3 and save 5%</strong></p>' +
      '<div class="wwp-fbt__thumbs">' + items.map(function (it, i) { return (i ? '<span class="wwp-fbt__plus">+</span>' : '') + '<img class="wwp-fbt__thumb" src="' + esc(it.img) + '" alt="">'; }).join('') + '</div>' +
      '<div class="wwp-fbt__list">' + items.map(function (it, i) {
        var av = avail(it), sel = '';
        if (i && av.length > 1) sel = '<select class="wwp-fbt__sel" aria-label="Choose option">' + av.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + ' \u2013 ' + gbp(v.price) + '</option>'; }).join('') + '</select>';
        return '<label class="wwp-fbt__item"><input type="checkbox" checked><span class="wwp-fbt__info"><span class="wwp-fbt__name">' + (i ? '' : 'This item: ') + esc(it.title) + '<span class="wwp-fbt__vt"></span></span>' + sel + '<span class="wwp-fbt__price"></span></span></label>';
      }).join('') + '</div>' +
      '<div class="wwp-fbt__foot"><div class="wwp-fbt__total-wrap">Total: <strong class="wwp-fbt__total-orig"></strong><span class="wwp-fbt__discount-line" hidden>\u2192 <strong class="wwp-fbt__total-disc"></strong> <span class="wwp-fbt__saving"></span></span></div><button type="button" class="wwp-fbt__btn">' + BAG + '<span></span></button></div>';
    rows = box.querySelectorAll('.wwp-fbt__item'); thumbs = box.querySelectorAll('.wwp-fbt__thumb');
    btn = box.querySelector('.wwp-fbt__btn'); label = btn.querySelector('span');
    totalEl = box.querySelector('.wwp-fbt__total-orig');
    discountEl = box.querySelector('.wwp-fbt__discount-line');
    var totalDisc = box.querySelector('.wwp-fbt__total-disc');
    var savingEl = box.querySelector('.wwp-fbt__saving');
    function pick(i) {
      var it = items[i], av = avail(it);
      if (!i) { var id = liveId(); return it.variants.filter(function (v) { return v.id === id; })[0] || av[0]; }
      var s = rows[i].querySelector('select'), sid = s ? parseInt(s.value, 10) : 0;
      return av.filter(function (v) { return v.id === sid; })[0] || av[0];
    }
    function refresh() {
      var total = 0, n = 0;
      items.forEach(function (it, i) {
        var v = pick(i), on = rows[i].querySelector('input').checked && v && v.a;
        rows[i].querySelector('.wwp-fbt__price').textContent = v ? gbp(v.price) : '';
        rows[i].querySelector('.wwp-fbt__vt').textContent = !i && v && v.title !== 'Default Title' ? ' \u2013 ' + v.title : '';
        thumbs[i].classList.toggle('is-off', !on);
        if (on) { total += v.price; n++; }
      });
      totalEl.textContent = gbp(total);
      // Show discount line only when all 3 items checked
      var allChecked = n === items.length && items.length === 3;
      if (allChecked) {
        var discounted = Math.round(total * (1 - FBT_DISCOUNT));
        var saving = total - discounted;
        totalDisc.textContent = gbp(discounted);
        savingEl.textContent = '(save ' + gbp(saving) + ')';
        discountEl.hidden = false;
        totalEl.style.textDecoration = 'line-through';
        totalEl.style.opacity = '0.5';
        totalEl.style.fontSize = '13px';
      } else {
        discountEl.hidden = true;
        totalEl.style.textDecoration = '';
        totalEl.style.opacity = '';
        totalEl.style.fontSize = '';
      }
      label.textContent = n ? 'Add ' + (n > 1 ? 'all ' + n + ' items' : 'item') + ' to Bag' + (allChecked ? ' (5% off)' : '') : 'Select an item';
      btn.disabled = !n;
    }
    box.addEventListener('change', refresh);
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('product-info')) setTimeout(refresh, 250); });
    btn.addEventListener('click', function () {
      var lines = [];
      var n = 0;
      items.forEach(function (it, i) { var v = pick(i); if (rows[i].querySelector('input').checked && v && v.a) { lines.push({ id: v.id, quantity: 1 }); n++; } });
      if (!lines.length) return;
      btn.disabled = true; label.textContent = 'Adding...';
      // Apply 5% discount via cart attributes when all 3 selected
      var payload = { items: lines, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname };
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload) })
        .then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) { label.textContent = res.description || 'Sorry, try again'; return; }
          label.textContent = 'Added to Bag';
          var d = document.querySelector('cart-drawer');
          if (d && typeof d.renderContents === 'function') d.renderContents(res); else location.href = root + 'cart';
        }).catch(function () { label.textContent = 'Try again'; })
        .then(function () { setTimeout(refresh, 1800); });
    });
    refresh();
  }
  function start() {
    var main = document.getElementById('MainContent');
    if (!main || main.querySelector('.wwp-pdp-bottom')) return;
    getJSON(root + 'products/' + handle + '.js').then(function (prod) {
      if (!prod || !prod.id) return;
      var wrap = document.createElement('div');
      wrap.className = 'wwp-pdp-bottom';
      wrap.innerHTML = '<section class="wwp-fbt" hidden></section><section class="wwp-pdp-also"><div class="wwp-pdp-also__box"></div></section>';
      main.appendChild(wrap);
      if (window.wwpUpsell) window.wwpUpsell.render(wrap.querySelector('.wwp-pdp-also__box'), { seedId: prod.id, exclude: [prod.id] });
      companions(prod).then(function (comps) {
        if (!comps.length) return;
        var fbt = wrap.querySelector('.wwp-fbt');
        buildFbt(fbt, [norm(prod)].concat(comps));
        fbt.hidden = false;
        [1500, 4000, 8000].forEach(function (ms) {
          setTimeout(function () {
            document.querySelectorAll('#MainContent .shopify-app-block').forEach(function (b) { if (/frequently\s+bought\s+together/i.test(b.textContent)) b.style.display = 'none'; });
          }, ms);
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
